import request  from '@/utils/request.js';
// 请求方法
// 'getlist': function (data) {
//       return request.get('/api/getdata/getlist', data, {}, 'pro')
// }, 
// 'getDIST': function (options) {
//     return request.post('/api/getdata/getDIST', {}, options, 'pro')
// },

/**
 * @name 首页模块
 */
// 获取地址列表
export const ceshi =(params) => {
      // return request.get('/sys/baseDict/queryChannleDict',params,{},'pro');
} 
